import React from 'react'
import NumberFormat, { InputAttributes } from 'react-number-format'
import { TextField } from '@mui/material'

import { INumberFormatCustom } from '../commonInterfaces'

const NumberFormatCustom = React.forwardRef<NumberFormat<InputAttributes>, INumberFormatCustom>(
  function NumberFormatCustom(props, ref) {
    const { onChange, ...other } = props

    return (
      <NumberFormat
        {...other}
        getInputRef={ref}
        type="tel"
        format="## / ##"
        placeholder="MM / YY"
        mask={['M', 'M', 'Y', 'Y']}
        allowNegative={false}
        onValueChange={(values) => {
          onChange({
            target: {
              name: props?.name,
              value: values.value,
            },
          })
        }}
      />
    )
  }
)

export default function CreditCardDate(): JSX.Element {
  return (
    <TextField
      className="credit-date"
      label="Expiration Date"
      name="credit-card-date"
      InputProps={{
        inputComponent: NumberFormatCustom as any,
      }}
      fullWidth
    />
  )
}
